import { render, staticRenderFns } from "./AppointmentEdit.vue?vue&type=template&id=ce79cc16"
import script from "./AppointmentEdit.vue?vue&type=script&lang=ts"
export * from "./AppointmentEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports